import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';
import { CustomCellRendererParams } from '@app/shared/components/cell-renderer/cell-renderer-params';
import { ColumnType } from '@app/shared/extra/column-type.enum';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'computed-cell-renderer',
  templateUrl: './computed-cell-renderer.component.html',
  standalone: false
})
export class ComputedCellRendererComponent implements ICellRendererAngularComp {
  public ColumnType = ColumnType;
  public params: CustomCellRendererParams;
  public formControl = new FormControl({disabled: true});

  private touchScreenQuery: MediaQueryList;

  /**
   * Check if the column is numerical.
   * @returns True if the column is numerical, false otherwise.
   */
  public get isNumericalColumn(): boolean {
    return this.params.colDef.type === ColumnType.NUMERICAL;
  }

  /**
   * Method used by Ag-grid to initialise the cell with grid parameters.
   * @param params parameters of the renderer cell.
   */
  public agInit(params: CustomCellRendererParams): void {
    this.params = params;
    if (!!params.formControl) {
      this.formControl = params.formControl;
    }
    // Set the validators of the control.
    this.formControl.setValidators(this.params.validators);
    // Set value to the control.
    // The control will check if it's valid or not.
    this.formControl.setValue(this.params.value);
    // If the control is invalid, show it on the GUI.
    if (this.formControl.invalid) {
      this.params.eGridCell.classList.add('error-cell');
    } else {
      this.params.eGridCell.classList.remove('error-cell');
    }
  }

  /**
   * On touch screen devices only, toggle the tooltip after pressing the icon.
   * @param tooltip MatTooltip to toggle.
   */
  public onClickTooltip(tooltip: MatTooltip): void {
    if (this.touchScreenQuery.matches) {
      tooltip.toggle();
    }
  }

  /**
   * Method used by Ag-Grid to tell the grid to refresh this cell
   * This component does not include refresh logic
   * @param params
   * @returns {boolean}
   */
  public refresh(_: ICellRendererParams): boolean {
    return false;
  }
}
